
import type { RouteObject } from 'react-router';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServiceDetailsPage = lazy(() => import('../pages/services/details'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const TeamPage = lazy(() => import('../pages/team/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const SuccessPage = lazy(() => import('../pages/success/page'));
const LinktreePage = lazy(() => import('../pages/linktree/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ArabicLandingPage = lazy(() => import('../pages/landing/page'));
const PlayroomLandingPage = lazy(() => import('../pages/landing/playroom'));

// Brand Pages
const PuzzleBrandPage = lazy(() => import('../pages/brands/puzzle'));
const EduXBrandPage = lazy(() => import('../pages/brands/edux'));
const PuzzlePlusBrandPage = lazy(() => import('../pages/brands/puzzle-plus'));
const PlaylandBrandPage = lazy(() => import('../pages/brands/playland'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/landing',
    element: <ArabicLandingPage />
  },
  {
    path: '/landing/playroom',
    element: <PlayroomLandingPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/services/:serviceSlug',
    element: <ServiceDetailsPage />
  },
  {
    path: '/projects',
    element: <ProjectsPage />
  },
  {
    path: '/team',
    element: <TeamPage />
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPage />
  },
  {
    path: '/success',
    element: <SuccessPage />
  },
  {
    path: '/linktree',
    element: <LinktreePage />
  },
  {
    path: '/brands/puzzle',
    element: <PuzzleBrandPage />
  },
  {
    path: '/brands/edux',
    element: <EduXBrandPage />
  },
  {
    path: '/brands/puzzle-plus',
    element: <PuzzlePlusBrandPage />
  },
  {
    path: '/brands/playland',
    element: <PlaylandBrandPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
